import { render, staticRenderFns } from "./extraInsightsForm.vue?vue&type=template&id=9ae1ade6&scoped=true&"
import script from "./extraInsightsForm.vue?vue&type=script&lang=js&"
export * from "./extraInsightsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae1ade6",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QSelect,QInput,QBtn,QIcon});
